import { EMPTY_VIEW_ICONS, EmptyView } from '@shared/components/ui/EmptyView';
import { ShippingRulePreset } from '../../models/ShippingRulePreset';
import { PresetCard } from './PresetCard';

interface PresetsGridProps {
  presets: ShippingRulePreset[];
  isFetching: boolean;
  hasActiveSearch: boolean;
  onApply: (preset: ShippingRulePreset) => void;
  onEdit: (preset: ShippingRulePreset) => void;
  onDuplicate: (preset: ShippingRulePreset) => void;
  onDelete: (preset: ShippingRulePreset) => void;
}

// Grilla responsiva que muestra las tarjetas de presets
export const PresetsGrid = ({
  presets,
  isFetching,
  hasActiveSearch,
  onApply,
  onEdit,
  onDuplicate,
  onDelete,
}: PresetsGridProps) => {
  // Estado vacío: sin presets y sin búsqueda activa
  if (presets.length === 0 && !isFetching) {
    return (
      <EmptyView
        type={hasActiveSearch ? 'noResults' : 'emptyState'}
        icon={EMPTY_VIEW_ICONS.DEFAULT}
        customAction={hasActiveSearch ? null : undefined}
      />
    );
  }

  return (
    // Grilla responsiva: 1 col en mobile, 2 en tablet, 3 en desktop
    <div
      className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 transition-opacity duration-200 ${
        isFetching ? 'opacity-50 pointer-events-none' : 'opacity-100'
      }`}
    >
      {presets.map((preset) => (
        /* Tarjeta individual de preset */
        <PresetCard
          key={preset.id}
          preset={preset}
          onApply={onApply}
          onEdit={onEdit}
          onDuplicate={onDuplicate}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
